import Vue from 'vue'
import App from './App.vue'
import Login from './pages/Login.vue'
import Admin from './pages/Admin.vue'
import VueRouter from 'vue-router'
import http from 'vue-resource'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(http)

const router = new VueRouter({
  routes: [
    { path: '/', component: App, name: 'map'},
    { path: '/login', component: Login, name: 'login' },
    { path: '/admin', component: Admin , name: 'admin'},
  ]
});
new Vue({
  router
}).$mount('#app')
